import { atom } from "recoil";

export const bestReviewTotalClickedState = atom<boolean>({
  key: "bestReviewTotalClickedState",
  default: false,
});
